.kg{gap:0.125rem;}